/**
 * The signed-in session in the browser (ADR-0014): the access token lives in memory only, never in storage;
 * the httpOnly refresh cookie restores it after a reload. A pending TOTP challenge is kept here too, so its
 * token never appears in the URL.
 */
export interface Session {
  token(): string | undefined;
  setToken(token: string): void;
  clear(): void;
  mfaToken(): string | undefined;
  setMfaToken(token: string | undefined): void;
  subscribe(listener: () => void): () => void;
}

export function createSession(): Session {
  let token: string | undefined;
  let mfa: string | undefined;
  const listeners = new Set<() => void>();
  const emit = () => {
    for (const listener of listeners) listener();
  };
  return {
    token: () => token,
    setToken(next) {
      token = next;
      mfa = undefined;
      emit();
    },
    clear() {
      token = undefined;
      mfa = undefined;
      emit();
    },
    mfaToken: () => mfa,
    setMfaToken(next) {
      mfa = next;
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
